
















































































import { Component, Mixins } from 'vue-property-decorator'

import ModalDialogHelper from '@/mixins/ModalDialogHelper'
import FeatureLimitsDisplay from '@/components/FeatureLimitsDisplay.vue'

import { sharedInstance as userMetaData } from '@/services/UserMetaDataService'

import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'

// import { sharedInstance as analytics } from '@/services/AnalyticsService'

const InvitesManagePanel = () => import('@/components/invites/InvitesManagePanel.vue')

interface InviteTierItem
{
	label: string
	icon: string
	values: number[]
}

@Component({
	components: {
		FeatureLimitsDisplay
	}
})
export default class InvitesInfoPanel extends Mixins(ModalDialogHelper)
{
	private inviteTiers = [1, 2, 3, 5, 8, 13]

	private data = {
		projects: {
			icon: 'folder',
			label: 'Project',
			values: [3, 3, 3, 3, 5, 10]
		},
		images: {
			label: 'Image',
			icon: 'image',
			values: [6, 8, 11, 20, 30, 50]
		},
		levels: {
			label: 'Level',
			icon: 'gamepad',
			values: [6, 8, 11, 20, 25, 50]
		},
		screens: {
			label: 'Screen',
			icon: 'application',
			values: [6, 8, 11, 15, 20, 50]
		},
		elements: {
			label: 'Custom Element',
			icon: 'star',
			values: [6, 8, 11, 15, 25, 50]
		},
		audio: {
			label: 'Sound',
			icon: 'music-note',
			values: [2, 4, 7, 15, 20, 50]
		}
	}

	private sizeData = {
		imageSize: {
			values: [
				{ width: 1024, height: 1024 },
				{ width: 1024, height: 1024 },
				{ width: 1024, height: 1024 },
				{ width: 1024, height: 1024 },
				{ width: 2048, height: 2048 },
				{ width: 2048, height: 2048 }
			]
		},
		audioSize: {
			values: [
				'1MB',
				'2MB',
				'3MB',
				'5MB',
				'5MB',
				'8MB'
			]
		}
	}

	get currentInvites()
	{
		return userMetaData.friendsInvited
	}

	get invitesToNextTier()
	{
		for (let i = 0; i < this.inviteTiers.length; ++i)
		{
			const tier = this.inviteTiers[i]
			if (!this.isNextTier(tier))
			{
				continue
			}

			return tier - this.currentInvites
		}

		return 0
	}

	private handleInvite()
	{
		// @ts-ignore
		this.$parent.close()

		// @ts-ignore
		const modal = this.$buefy.modal.open({
			// parent: this,
			component: InvitesManagePanel,
			hasModalCard: true
		})

		this.bringToFront(modal)
	}

	private getTooltip(value: number, index: number, item: InviteTierItem, key: string)
	{
		const baseInfo = `${value} ${this.pluralize(item.label, value)}`

		switch (key)
		{
			case 'levels':
			case 'screens':
			case 'elements':
			case 'projects':
			{
				return `Create up to ${baseInfo}`
			}

			case 'audio':
			{
				const size = this.sizeData.audioSize.values[index]
				return `Upload up to ${baseInfo} (Max ${size} each)`
			}

			case 'images':
			{
				const size = this.sizeData.imageSize.values[index]
				return `Upload up to ${baseInfo} (Max ${size.width}x${size.height} each)`
			}
		}

		return baseInfo
	}

	private isTooltipMultiline(key: string)
	{
		return key === 'audio' || key === 'images'
	}

	private getTooltipSize(key: string)
	{
		switch (key)
		{
			default:
				return 'is-medium'

			case 'audio':
			case 'images':
				return 'is-small'
		}
	}

	private getTopClasses(value: number)
	{
		const nextTier = this.isNextTier(value)

		return {
			column: true,
			'is-2': true,
			'has-text-centered': true,
			'pa-1': true,
			'rounded-top': nextTier,
			'has-background-primary-lighter': nextTier,
			'has-text-light': nextTier,
			'has-text-weight-semibold': true
		}
	}

	private getHeaderClasses(value: number)
	{
		const nextTier = this.isNextTier(value)

		return {
			column: true,
			'is-2': true,
			'has-text-centered': true,
			'has-text-light': !nextTier,
			'has-background-secondary': nextTier,
			'has-text-black': nextTier,
			'has-text-weight-semibold': true
		}
	}

	private getFeatureClasses(value: number, last: boolean)
	{
		const nextTier = this.isNextTier(value)

		return {
			column: true,
			'is-2': true,
			'has-text-centered': true,
			'has-text-light': !nextTier,
			'has-background-secondary': nextTier,
			'has-text-black': nextTier,
			'rounded-bottom': nextTier && last
		}
	}

	private isNextTier(value: number)
	{
		switch (value)
		{
			case 1:
				return this.currentInvites === 0

			case 2:
				return this.currentInvites === 1

			case 3:
				return this.currentInvites === 2

			case 5:
				return this.currentInvites === 3

			case 8:
				return this.currentInvites === 5

			case 13:
				return this.currentInvites === 8
		}

		return false
	}

	private displayValue(value: number | string | { width: number, height: number })
	{
		if (isNumber(value) || isString(value))
		{
			return value
		}

		// @ts-ignore
		return `${value.width}x${value.height}`
	}

	private pluralize(singular: string, count: number)
	{
		// NOTE: there is a more sophisticated library on npm
		// called pluralize
		if (count === 1)
		{
			return singular
		}

		return `${singular}s`
	}
}

